import React, { useEffect, useRef } from "react";
import OTPInput from "react-otp-input";
import { Spinner } from "reactstrap";
import close from "../assets/V2-images/close.svg";

const CommonAuthPopup = ({
  isOpen,
  mode, // "email" | "otp"
  email,
  setEmail,
  otp,
  setOtp,
  onSubmit,
  onClose,
  buttonLoading,
}) => {
  const emailRef = useRef(null);
  const otpRef = useRef(null);

  useEffect(() => {
    if (mode === "email") {
      setTimeout(() => emailRef.current?.focus(), 100);
    }
    if (mode === "otp") {
      setTimeout(() => otpRef.current?.focus(), 100);
    }
  }, [mode]);
  // useEffect(() => {
  //   if (otp.length === 6) {
  //     onSubmit();
  //   }
  // }, [otp]);
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        width: "400px",
        zIndex: 1000,
      }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center">
        <h4>{mode === "email" ? "Email" : "Enter OTP"}</h4>
        {/* <img
          src={close}
          alt="close"
          onClick={onClose}
          style={{ cursor: "pointer", width: "20px" }}
        /> */}
      </div>

      {/* Body */}
      <div style={{ margin: "20px 0" }}>
        {mode === "email" && (
          <input
            ref={emailRef}
            type="email"
            className="Custom-input"
            value={email}
            onChange={(e) => setEmail((e.target.value).toLowerCase())}
            onKeyDown={(e) => e.key === "Enter" && onSubmit()}
            placeholder="Enter email"
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
            }}
          />
        )}

        {mode === "otp" && (
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            shouldAutoFocus
            inputType="tel"
            containerStyle={{
              display: "flex",
              justifyContent: "center",
              gap: "8px",
            }}
            renderInput={(props) => <input {...props} />}
            inputStyle={{
              width: "2.5rem",
              height: "2.5rem",
              fontSize: "16px",
              textAlign: "center",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />
        )}
      </div>

      {/* Footer */}
      <div className="d-flex justify-content-end">
        <button
          className="Primary-Button d-flex gap-2 align-items-center"
          onClick={onSubmit}
          disabled={buttonLoading}
        >
          {mode === "email" ? "Proceed" : "Submit"}
          {buttonLoading && <Spinner size="sm" />}
        </button>
      </div>
    </div>
  );
};

export default CommonAuthPopup;
